import { Action, createReducer, on } from '@ngrx/store';
import { SetActiveMediaQueries } from '../actions/media.actions';

export interface State {
    activeMediaQueries: string[];
}

export const initialState: State = {
    activeMediaQueries: []
};

const mediaReducer = createReducer(
    initialState,
    on(SetActiveMediaQueries, (state, { activeMediaQueries }): State => ({ ...state, activeMediaQueries })),
);

export function reducer(state: State | undefined, action: Action) {
    return mediaReducer(state, action);
}

export const selectActiveMediaQueries = (state: State) => state.activeMediaQueries;
